import { render, staticRenderFns } from "./InputSelectLanguage.vue?vue&type=template&id=1077c2f5"
import script from "./InputSelectLanguage.vue?vue&type=script&lang=js"
export * from "./InputSelectLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports